import React from "react";

export default function Breadcrumb(props) {
  const { pageName, category, subcategory } = props;

  return (
    <div>
      <div className="page-title-box d-flex justify-content-between">
        <h4 className="mb-0">{pageName}</h4>
        <div className="">
          <ol className="breadcrumb m-0">
            <li className="breadcrumb-item">{category}</li>
            <li className="breadcrumb-item active">{subcategory}</li>
          </ol>
        </div>
      </div>
    </div>
  );
}
